import React, { Component, PropTypes } from 'react';
import SearchBar from 'components/Tasks/SearchBar';
import ScrollableContainer from 'components/Tasks/ScrollableContainer';
import { List, ListItem } from 'components/List';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    position: 'relative',
    width: 48,
    '&expanded': {
      width: 256
    }
  },
  uncorrected: {
    position: 'absolute',
    backgroundColor: '#DDDDDD',
    padding: 4,
    borderRadius: 3,
    left: 4,
    top: 4,
    fontSize: 10
  }
});

class SearchList extends Component {
  static propTypes = {
    items: PropTypes.array,
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onTouchTapItem: PropTypes.func,
    expanded: PropTypes.bool
  };

  onTouchTapItem = item => {
    const { onTouchTapItem } = this.props;
    onTouchTapItem && onTouchTapItem(item);
  };

  render() {
    const { items, expanded, selected, ...other } = this.props;
    const classes = classNames(css.root, {
      [css.expanded]: expanded
    });
    if (!expanded) {
      return <SearchBar expanded={expanded} {...other} />;
    }
    return (
      <ScrollableContainer
        className={classes}
        header={<SearchBar expanded={expanded} {...other} />}
      >
        <List>
          {items.map(item => {
            return (
              <ListItem
                key={item.id}
                selected={selected === item.id}
                onTouchTap={this.onTouchTapItem.bind(this, item)}
              >
                {item.uncorrectedCount > 0 ? (
                  <div className={css.uncorrected}>{item.uncorrectedCount}</div>
                ) : null}
                {item.name}
              </ListItem>
            );
          })}
        </List>
      </ScrollableContainer>
    );
  }
}

export default SearchList;



// WEBPACK FOOTER //
// ./src/js/components/Tasks/SearchList.js